import { TRANSACTION_DIRECTION } from '#client/constants/transaction';

/**
 * Function convert cent to usd with comma and dot
 *
 * @param {number} number - The cent money - 100000000 cent
 * @returns {string} - The usd money - 10,000,000.00$
 *
 */
export const formatNumber = (number) => {
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  return formatter.format(number / 100);
};

export const formatMoneyInOut = (direction, formattedAmount, isPayment = false) => {
  const isCredit = direction === TRANSACTION_DIRECTION.CREDIT;
  const isDebit = direction === TRANSACTION_DIRECTION.DEBIT;
  const isPositive = (isCredit && !isPayment) || (isDebit && isPayment);
  if (isPositive) {
    return `${formattedAmount}`;
  }
  return `-${formattedAmount}`;
};

/**
 *
 * @param {*} direction - distinguishing between debit or credit
 * @param {*} formattedAmount - amount each transaction
 * @param {*} isPayment - distinguishing between transaction or payment(pending)
 * @returns amount formatted - +$20 if transaction or $20 if payment
 */

export const formatMoneyInOutUpdate = (direction, formattedAmount, isPayment = false) => {
  const isCredit = direction === TRANSACTION_DIRECTION.CREDIT;
  const isDebit = direction === TRANSACTION_DIRECTION.DEBIT;
  const isPositive = (isCredit && !isPayment) || (isDebit && isPayment);
  if (isPositive) {
    return `+${formattedAmount}`;
  }
  return `${formattedAmount}`;
};
